import { instance } from "../axios/axiosConfig";
import {
  BrandEditByIdDataType,
  SwitchBrandBodyType,
} from "../types/brandTypes.tsx";

const brandApi = {
  fetchBrandsList() {
    return instance.get(`/api/brand-view/`);
  },
  fetchBrandById(id: string) {
    return instance.get(`/api/brand-view/${id}/`);
  },
  createBrand(body: FormData) {
    return instance.post(`/api/brand-view/`, body);
  },
  deleteBrand(id: string) {
    return instance.delete(`/api/brand-view/${id}/`);
  },
  editBrandById(data: BrandEditByIdDataType) {
    return instance.patch(`/api/brand-view/${data.id}/`, data.body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  switchBrand(body: SwitchBrandBodyType) {
    return instance.post(`/api/switch-brand/`, body);
  },
  completeOnboarding(brandId: string) {
    return instance.post(`/api/brand-view/${brandId}/complete-onboarding/`);
  },
};

export default brandApi;
